import { render, staticRenderFns } from "./wechatwrdialog.vue?vue&type=template&id=38d30813&scoped=true"
import script from "./wechatwrdialog.vue?vue&type=script&lang=js"
export * from "./wechatwrdialog.vue?vue&type=script&lang=js"
import style0 from "./wechatwrdialog.vue?vue&type=style&index=0&id=38d30813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d30813",
  null
  
)

export default component.exports